import { NgModule } from '@angular/core';
import { ConfigModule } from './config/config.module';

/**
 * Wiring shell. There is no routing module: the inbox lives in the header bell
 * and the admin screens live under the existing `administration` routes, so
 * this feature contributes endpoint config only.
 */
@NgModule({ imports: [ConfigModule] })
export class NotificationsModule {}
